import { useQuery } from "@tanstack/react-query";
import type {
  CheckoutSupplierPaymentOptionsRequestType,
  CheckoutSupplierPaymentOptionsResponseType,
} from "@sellar-io/api-v2/types";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  ApiV2QueryOptions,
  apiV2Request,
  getDefaultQueryOptionsV2,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useCheckoutSupplierPaymentOptions = <
  TData = CheckoutSupplierPaymentOptionsResponseType,
>(
  params: CheckoutSupplierPaymentOptionsRequestType,
  options?: ApiV2QueryOptions<TData>,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useQuery({
    staleTime: 1000 * 60 * 60,
    queryKey: [
      user?.uid,
      business?.id,
      ServerStateKeys.CheckoutPaymentOptionsSupplier,
      params,
    ],
    queryFn: () =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `checkout/payment-options/supplier`,
        data: params,
      }).then((data) => apiV2AssertResponse<TData>(data).data),
    ...getDefaultQueryOptionsV2({
      context: { scope: "business", user, business: business },
      options: options,
    }),
  });
};
